module.exports = __webpack_public_path__ + "img/chinook.feb37621.jpg";